/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateDictionaryPermissionDto } from '../models';
// @ts-ignore
import { DirectoryPermissionEntity } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { UpdateDirectoryPermissionDto } from '../models';
/**
 * DirectoryPermissionApi - axios parameter creator
 * @export
 */
export const DirectoryPermissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new directory permission
         * @param {CreateDictionaryPermissionDto} createDictionaryPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectoryPermission: async (createDictionaryPermissionDto: CreateDictionaryPermissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDictionaryPermissionDto' is not null or undefined
            assertParamExists('createDirectoryPermission', 'createDictionaryPermissionDto', createDictionaryPermissionDto)
            const localVarPath = `/api/v1.0/directory-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDictionaryPermissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a directory permission
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectoryPermission: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDirectoryPermission', 'id', id)
            const localVarPath = `/api/v1.0/directory-permissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all directory permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDirectoryPermissions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/directory-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get directory permission by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectoryPermissionById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDirectoryPermissionById', 'id', id)
            const localVarPath = `/api/v1.0/directory-permissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a directory permission
         * @param {string} id 
         * @param {UpdateDirectoryPermissionDto} updateDirectoryPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDirectoryPermission: async (id: string, updateDirectoryPermissionDto: UpdateDirectoryPermissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDirectoryPermission', 'id', id)
            // verify required parameter 'updateDirectoryPermissionDto' is not null or undefined
            assertParamExists('updateDirectoryPermission', 'updateDirectoryPermissionDto', updateDirectoryPermissionDto)
            const localVarPath = `/api/v1.0/directory-permissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDirectoryPermissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DirectoryPermissionApi - functional programming interface
 * @export
 */
export const DirectoryPermissionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DirectoryPermissionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new directory permission
         * @param {CreateDictionaryPermissionDto} createDictionaryPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDirectoryPermission(createDictionaryPermissionDto: CreateDictionaryPermissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectoryPermissionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDirectoryPermission(createDictionaryPermissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a directory permission
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDirectoryPermission(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectoryPermissionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDirectoryPermission(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all directory permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDirectoryPermissions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DirectoryPermissionEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDirectoryPermissions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get directory permission by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectoryPermissionById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectoryPermissionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectoryPermissionById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a directory permission
         * @param {string} id 
         * @param {UpdateDirectoryPermissionDto} updateDirectoryPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDirectoryPermission(id: string, updateDirectoryPermissionDto: UpdateDirectoryPermissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectoryPermissionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDirectoryPermission(id, updateDirectoryPermissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DirectoryPermissionApi - factory interface
 * @export
 */
export const DirectoryPermissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DirectoryPermissionApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new directory permission
         * @param {CreateDictionaryPermissionDto} createDictionaryPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectoryPermission(createDictionaryPermissionDto: CreateDictionaryPermissionDto, options?: any): AxiosPromise<DirectoryPermissionEntity> {
            return localVarFp.createDirectoryPermission(createDictionaryPermissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a directory permission
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectoryPermission(id: string, options?: any): AxiosPromise<DirectoryPermissionEntity> {
            return localVarFp.deleteDirectoryPermission(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all directory permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDirectoryPermissions(options?: any): AxiosPromise<Array<DirectoryPermissionEntity>> {
            return localVarFp.getAllDirectoryPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get directory permission by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectoryPermissionById(id: string, options?: any): AxiosPromise<DirectoryPermissionEntity> {
            return localVarFp.getDirectoryPermissionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a directory permission
         * @param {string} id 
         * @param {UpdateDirectoryPermissionDto} updateDirectoryPermissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDirectoryPermission(id: string, updateDirectoryPermissionDto: UpdateDirectoryPermissionDto, options?: any): AxiosPromise<DirectoryPermissionEntity> {
            return localVarFp.updateDirectoryPermission(id, updateDirectoryPermissionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDirectoryPermission operation in DirectoryPermissionApi.
 * @export
 * @interface DirectoryPermissionApiCreateDirectoryPermissionRequest
 */
export interface DirectoryPermissionApiCreateDirectoryPermissionRequest {
    /**
     * 
     * @type {CreateDictionaryPermissionDto}
     * @memberof DirectoryPermissionApiCreateDirectoryPermission
     */
    readonly createDictionaryPermissionDto: CreateDictionaryPermissionDto
}

/**
 * Request parameters for deleteDirectoryPermission operation in DirectoryPermissionApi.
 * @export
 * @interface DirectoryPermissionApiDeleteDirectoryPermissionRequest
 */
export interface DirectoryPermissionApiDeleteDirectoryPermissionRequest {
    /**
     * 
     * @type {string}
     * @memberof DirectoryPermissionApiDeleteDirectoryPermission
     */
    readonly id: string
}

/**
 * Request parameters for getDirectoryPermissionById operation in DirectoryPermissionApi.
 * @export
 * @interface DirectoryPermissionApiGetDirectoryPermissionByIdRequest
 */
export interface DirectoryPermissionApiGetDirectoryPermissionByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DirectoryPermissionApiGetDirectoryPermissionById
     */
    readonly id: string
}

/**
 * Request parameters for updateDirectoryPermission operation in DirectoryPermissionApi.
 * @export
 * @interface DirectoryPermissionApiUpdateDirectoryPermissionRequest
 */
export interface DirectoryPermissionApiUpdateDirectoryPermissionRequest {
    /**
     * 
     * @type {string}
     * @memberof DirectoryPermissionApiUpdateDirectoryPermission
     */
    readonly id: string

    /**
     * 
     * @type {UpdateDirectoryPermissionDto}
     * @memberof DirectoryPermissionApiUpdateDirectoryPermission
     */
    readonly updateDirectoryPermissionDto: UpdateDirectoryPermissionDto
}

/**
 * DirectoryPermissionApi - object-oriented interface
 * @export
 * @class DirectoryPermissionApi
 * @extends {BaseAPI}
 */
export class DirectoryPermissionApi extends BaseAPI {
    /**
     * 
     * @summary Create a new directory permission
     * @param {DirectoryPermissionApiCreateDirectoryPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectoryPermissionApi
     */
    public createDirectoryPermission(requestParameters: DirectoryPermissionApiCreateDirectoryPermissionRequest, options?: AxiosRequestConfig) {
        return DirectoryPermissionApiFp(this.configuration).createDirectoryPermission(requestParameters.createDictionaryPermissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a directory permission
     * @param {DirectoryPermissionApiDeleteDirectoryPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectoryPermissionApi
     */
    public deleteDirectoryPermission(requestParameters: DirectoryPermissionApiDeleteDirectoryPermissionRequest, options?: AxiosRequestConfig) {
        return DirectoryPermissionApiFp(this.configuration).deleteDirectoryPermission(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all directory permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectoryPermissionApi
     */
    public getAllDirectoryPermissions(options?: AxiosRequestConfig) {
        return DirectoryPermissionApiFp(this.configuration).getAllDirectoryPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get directory permission by ID
     * @param {DirectoryPermissionApiGetDirectoryPermissionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectoryPermissionApi
     */
    public getDirectoryPermissionById(requestParameters: DirectoryPermissionApiGetDirectoryPermissionByIdRequest, options?: AxiosRequestConfig) {
        return DirectoryPermissionApiFp(this.configuration).getDirectoryPermissionById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a directory permission
     * @param {DirectoryPermissionApiUpdateDirectoryPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectoryPermissionApi
     */
    public updateDirectoryPermission(requestParameters: DirectoryPermissionApiUpdateDirectoryPermissionRequest, options?: AxiosRequestConfig) {
        return DirectoryPermissionApiFp(this.configuration).updateDirectoryPermission(requestParameters.id, requestParameters.updateDirectoryPermissionDto, options).then((request) => request(this.axios, this.basePath));
    }
}
